export default {
  install (Vue, options) {
    Vue.prototype.$parseFieldDataValue = (field) => {
      let isFile = (field.field_type == 'file' && field.value != undefined)
      if (isFile) {
        let value = field.value.replace(/'/g, "\"")
        value = JSON.parse(value)
        return `<a href='${value.url}' target='_blank'> ${value.name}</a>`
      } else if (field.field_type == 'rate') {
          return field.value ? field.value + "%" : "-"   
      } else {
        if (isNaN(field.value)){
          if (field.value == 'True' || field.value == 'False')
            return Boolean(field.value) ? "SI":"NO"
          else
            return field.value
        } else {
            if (field.field_type == 'select' || field.field_type == 'radio') {
              return field.display_value
            }
           
            return Number(field.value)
        }
      }
    }
  }
}
